import axios from "axios";  
import Vue from 'vue'

export const state = {};

export const getters = { };

export const mutations = {
  
  ClearJWToken() {
    window.$cookies.remove("ecampus",null,Vue.prototype.$config.COOKIES_DOMAIN);  
  },
};

export const actions = {

  //GET
  async ActionsGet({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    return axios
      .get(
        Data["Service"] +
          "?PageNumber=" +
          Data["Page"].PageNumber +
          "&PageSize=" +
          Data["Page"].PageSize
      )
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){   
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
  },

  //GET Single
  async ActionsSingleGet({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    return axios
      .get(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
  },

  //FİLTER GET 
 async ActionsFilterGet({dispatch}, Data) {  
  dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
  return axios
    .get(
      Data["Service"] +
        "?PageNumber=" +
        Data["Page"].PageNumber +
        "&PageSize=" +
        Data["Page"].PageSize +
        Data["Filter"]
    )
    .then((res) => res.data)
    .catch((error) => {  
      if(error.response.status == 401){    
        dispatch("logOut"); 
        return error.response.data 
      }else{
        return error.response.data 
      }
    });
}, 
  //FİLE GET 
  async ActionsFileGet({dispatch}, Data) {  
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })

    return axios({
      url: Data["Service"]+Data["Filter"], // File URL Goes Here
      method: 'GET',
      responseType: 'blob',
  }) .then((res) => res.data)
  .catch((error) => {  
    if(error.response.status == 401){    
      dispatch("logOut"); 
      return error.response.data 
    }else{
      return error.response.data 
    }
  });

 
  }, 

  //POST
  async ActionsPost({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    return axios
      .post(Data["Service"], Data["Data"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          console.log(error.response.data.Message); 
          return error.response.data 
        }
      });
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  }, 
  
  //PUT
  async ActionsPut({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    return axios
      .put(Data["Service"] + "/" + Data["Data"].Id, Data["Data"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });

  },
    //PUT
    async ActionsAllPut({dispatch}, Data) {
      dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })

      return axios
        .put(Data["Service"]+"/" , Data["Data"])
        .then((res) => res.data)
        .catch((error) => {  
          if(error.response.status == 401){    
            dispatch("logOut"); 
            return error.response.data 
          }else{
            return error.response.data 
          }
        });

    },
    
   async Report({dispatch}, Data) {   
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })

    var format = "1";
    if(Data["FileFormat"] == "xlsx"){ format = 0 }
    if(Data["FileFormat"] == "docx"){ format = 2 }
 
    var link = Data["Service"] +"?ReportName=" +Data["FileName"] +"&ReportType=" +format 
    try {
      const response = await axios.get(link + Data["Filter"], { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const linkElement = document.createElement('a');
      linkElement.href = url;
      const contentDisposition = response.headers['content-disposition'];
      let fileName = Data["DowlandName"]+'.'+Data["FileFormat"]; // Default file name
      if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
          }
      }
      linkElement.setAttribute('download', fileName);
      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);
  } catch (error) {
      console.error('Dosya indirme hatası:', error);
      return error.response.data;
  }
}, 

      //PUTList
  async ActionsPutList({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    return axios
      .put(Data["Service"], Data["Data"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  },

  //DELETE
  async ActionsDelete({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    return axios
      .delete(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
  },

  //SABİTLER
  async ActionsSabitGet({dispatch}, Tip) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    return axios
      .get("OKeyValues?Tip=" + Tip + "&PageNumber=1&PageSize=9999")
      .then((res) => {
        return res.data;
      });
  },

  //FastReport
  async FastReport({dispatch}, Data) {  
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    axios({
      url: "GenericReport",
      method: "POST",
      responseType: "blob",
      data: Data,
    })
      .then((response) => {
    //YENİ SEKMEDE AÇMAK İÇİN
        let blob = new Blob([response.data], { type: "application/pdf" }),
        url = window.URL.createObjectURL(blob); 
        window.open(url);
      })
      .catch((error) => error.response.data);
    /* DİREK İNDİRMEK İÇİN 
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a'); 
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'file.pdf');
        document.body.appendChild(fileLink); 
        fileLink.click();
    */
  },
  logOut({commit}){    
    commit("ClearJWToken")  
    window.location=this.$config.LOGIN_URL

    },
  
   
};
